import {Stack, Typography} from '@mui/material';
import {Loading} from 'presentation/components/Loading/Loading';
import Icon from 'presentation/icons';
import React from 'react';

import {ConfirmationCard} from 'presentation/pages/private/booking/components';
import {useDocumentItem} from './hooks/useDocumentItem';
import {StyledIconButton} from './styles';
import {DocumentItemProps} from './types';

export function DocumentItem({id, filename, pathURL}: DocumentItemProps) {
	const {isDownloading, isOpening, handleDownload, openPdf} = useDocumentItem({
		id,
		filename,
		pathURL,
	});

	return (
		<ConfirmationCard.Root>
			<Stack
				justifyContent="space-between"
				alignItems="center"
				direction="row"
				gap={1}
				flex={1}>
				<Typography variant="body1">{filename}</Typography>
				<Stack direction="row" gap={2}>
					<StyledIconButton onClick={openPdf} color="primary" size="large">
						{isOpening ? <Loading size={16} /> : <Icon name="ben-export" size={16} />}
					</StyledIconButton>
					<StyledIconButton color="primary" size="large" onClick={handleDownload}>
						{isDownloading ? <Loading size={16} /> : <Icon name="download" size={16} />}
					</StyledIconButton>
				</Stack>
			</Stack>
		</ConfirmationCard.Root>
	);
}
